import React from 'react';
import useSessionStorage from '../../../hooks/useSessionStorage';
import DropDown from '../TextField/dropDown';

const MultiselectDroDown = ({ data, type, error, updateDynamicFilter, commonselctRef, index }) => {
    return (
        <DropDown name={data?.name} label={data?.label}
            placeholder={"Select Location Name"} updateValue={(target) => {
                updateDynamicFilter(target, type, data?.formsSectionID)
            }}
            value={data?.selectedValueOptions}
            options={data?.options} showArrow={true} isObject={true} multiple={true}
            errors={error['']} divClass='w-100' multiselectRef={(el) => (commonselctRef.current[index] = el)} />
    )
}

const DynamicFilter = (props) => {
    const { commonselctRef, filterControls, updateDynamicFilter } = props
    const storage = useSessionStorage();
    const inputTypes = storage.getItem('inputTypes');


    return (
        <>
            {
                filterControls && inputTypes && filterControls.map((item, index) => (
                    <>
                        {
                            inputTypes.ReactMultiSelectDropdown === item.filterControlType ? (<MultiselectDroDown data={item}
                                type={'ReactMultiSelectDropdown'}
                                error={''}
                                updateDynamicFilter={updateDynamicFilter}
                                commonselctRef={commonselctRef}
                                index={index}
                            />)
                                : ('')
                        }
                    </>

                ))
            }
        </>
    )
}

export default DynamicFilter;
